module.exports = __webpack_public_path__ + "img/s2s_logo.b172c79f.png";